/**
 * Prompt new users to create a G2MM URL.
 */
define('setup/free-trial/free-trial',['require','api-access','../setup-configurator','mixpanel-helper','plugins/router','tealium-utils'],function (require) {
    var goToMeetApi = require('api-access').gotomeet;
    var setupConfigurator = require('../setup-configurator');
    var mixpanelHelper = require('mixpanel-helper');
    var router = require('plugins/router');
    var tealiumUtils = require('tealium-utils');

    return function () {
        var self = this;

        self.activate = function () {
            self.setupConfig = setupConfigurator.getSetupData();

            var activateRequirement = $.Deferred();

            goToMeetApi.getByUserKey()
                .then(function (g2mmProfile) {
                    self.contentView = {
                        model: 'setup/free-trial/free-trial-features',
                        activationData: {
                            profileId: g2mmProfile.profileId,
                            nextUrl: self.setupConfig['free-trial'].nextUrl
                        }
                    };

                    activateRequirement.resolve();
                })

                .fail(function () {
                    self.contentView = {
                        model: 'setup/free-trial/free-trial-features',
                        activationData: {
                            nextUrl: self.setupConfig['free-trial'].nextUrl
                        }
                    };

                    activateRequirement.resolve();
                });

            return activateRequirement.promise();
        };

        self.compositionComplete = function () {
            tealiumUtils.sendTealiumEvent('welcome-free-judo-flip', 'meetings');
            mixpanelHelper.track('Loaded Free Trial page');
        };

        self.getStarted = function () {
            if (self.setupConfig && self.setupConfig['free-trial'] && self.setupConfig['free-trial'].nextUrl) {
                router.navigate(self.setupConfig['free-trial'].nextUrl);
            }
        };
    };
});

